module.exports = __webpack_public_path__ + "static/media/slide_one.resized.a9bf98be.jpg";